module.exports = __webpack_public_path__ + "img/vegetable-broccoli-190x100.66898a63.jpg";